import { render, staticRenderFns } from "./CoalitionForces.vue?vue&type=template&id=2e51d221&scoped=true"
import script from "./CoalitionForces.vue?vue&type=script&lang=js"
export * from "./CoalitionForces.vue?vue&type=script&lang=js"
import style0 from "./CoalitionForces.vue?vue&type=style&index=0&id=2e51d221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51d221",
  null
  
)

export default component.exports